
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { TextField } from "@goodgamestudios/createjs-utilities";

import { SFConstants } from "../../constants/SFConstants";
import { Poker2BuddyEvent } from "../../event/Poker2BuddyEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;

import MouseEvent = createjs.MouseEvent;

export class Poker2InviteFriendDialog extends Poker2Dialog {
    public static NAME: string = "Poker2InviteFriendDialog";
    private isWaitingForServerMessage: boolean = false;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.isWaitingForServerMessage = false;
        this.inviteDialog.btn_yes.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.inviteDialog.txt_title, Poker2Model.languageData.getTextById("dialog_invitefriend_title"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.inviteDialog.txt_myname, Poker2Model.languageData.getTextById("dialog_invitefriend_myname"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.inviteDialog.txt_friendmail, Poker2Model.languageData.getTextById("dialog_invitefriend_friendname"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.inviteDialog.txt_friendname, Poker2Model.languageData.getTextById("dialog_invitefriend_friendmail"));

        this.controller.addEventListener("inviteFriendFaild", this.bindFunction(this.onFaild));
        this.controller.addEventListener("inviteFriendComplete", this.bindFunction(this.onInvited));

        this.inviteDialog.mc_myname.inputField.text = Poker2Model.userData.userName;
        this.inviteDialog.mc_friendname.inputField.text = "";
        this.inviteDialog.mc_friendmail.inputField.text = "";
        super.applyProperties();
    }

    private onInvited(e: Poker2BuddyEvent): void {
        this.hide();
    }
    private onFaild(e: Poker2BuddyEvent): void {
        this.inviteDialog.mc_friendmail.inputField.text = "";
        this.isWaitingForServerMessage = false;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.inviteDialog.btn_yes:
                this.onInviteFriend();
                break;
            case this.inviteDialog.btn_close:
                this.hide();
                break;
            case this.inviteDialog.mc_myname.inputField:
            case this.inviteDialog.mc_friendname.inputField:
            case this.inviteDialog.mc_friendmail.inputField:
                (event.target as TextField).setSelection(0, (event.target as TextField).text.length);
                break;
        }
    }

    private onInviteFriend(): void {
        if (this.isWaitingForServerMessage)
            return;
        if (this.inviteDialog.mc_myname.inputField.text == "") {
            this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(
                Poker2Model.languageData.getTextById("generic_alert_bug"),
                Poker2Model.languageData.getTextById("alert_invitefriend_emptyerror")));
            return;
        }
        if (this.inviteDialog.mc_friendmail.inputField.text == "" || !TextValide.isSmartFoxValide(this.inviteDialog.mc_friendmail.inputField.text)) {
            this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(
                Poker2Model.languageData.getTextById("generic_alert_bug"),
                Poker2Model.languageData.getTextById("generic_register_emailwrong_copy")));
            return;
        }
        this.isWaitingForServerMessage = true;
        var paramObject: any = {
            ownname: this.inviteDialog.mc_myname.inputField.text,
            friendname: this.inviteDialog.mc_friendname.inputField.text,
            friendmail: this.inviteDialog.mc_friendmail.inputField.text
        };
        this.controller.sendServerMessageAndWait("cif", [JSON.stringify(paramObject)], "cif");
    }

    public checkWaitingAnimState(message: string): void {
        if (message == "cif")
            this.isWaitingForServerMessage = false;
    }

    public hide(): void {
        super.hide();
        this.controller.removeEventListener("inviteFriendFaild", this.bindFunction(this.onFaild));
        this.controller.removeEventListener("inviteFriendComplete", this.bindFunction(this.onInvited));
    }

    protected get inviteDialog(): Library.PokerInterface.PokerInviteFriend {
        return this.disp as Library.PokerInterface.PokerInviteFriend;
    }
}
import { Poker2WarningDialog } from "./Poker2WarningDialog";
